/* global ResizeObserver */

// This is some JS to help us with multi-line text truncation as seen in this demo:
// https://paulbakaus.com/tutorials/css/multiline-truncated-text-with-show-more-button-with-just-css/

import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = ['content']
  static classes = ['truncated', 'expanded']

  connect () {
    const wrapper = this.element

    this.observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        wrapper.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove'](this.truncatedClass)
      }
    })

    this.observer.observe(this.contentTarget)
  }

  disconnect () {
    this.observer.disconnect()
  }

  expand () {
    this.element.classList.add(this.expandedClass)
  }
}
